<template>
  <div class="m-detail clearfix">
    <div class="content_title">
      <p class="title">{{ title }}</p>
      <div class="content-pics">
        发布时间: <span class="content-detail">{{ publishTime }}</span>
        稿源单位: <span class="content-detail">{{ origin }}</span>
        作者: <span class="content-detail"> {{ author }}</span>
        浏览量: <span class="content-detail">{{ countView }}</span>
      </div>
    </div>
    <div class="content-info clearfix" v-html="content" />
    <div v-if="editor" class="info-editor" style="text-align: right">责任编辑： {{ editor }} </div>
    <div v-if="attachedList.length" class="infos">
      <div class="title">附件</div>
      <p v-for="{id, attachedName, attachedUrl, type} in attachedList" :key="id">
        <i class="el-icon-document" />
        {{ attachedName }}
        <template v-if="type && !isEdge">
          <a @click="getFile(attachedUrl, attachedName)">下载</a>
        </template>
        <a v-else @click="downLoadFile(attachedUrl, attachedName)">下载</a>
      </p>
    </div>
  </div>
</template>

<script>
import { getNewsInfo } from '@/apis/user'

export default {
  data() {
    return {
      title: '',
      publishTime: '',
      origin: '',
      author: '',
      lookNumber: '',
      content: '',
      countView: '',
      editor: '',
      attachedList: [],
      isEdge: false
    }
  },
  mounted() {
    this.init()
    const { userAgent } = navigator
    this.isEdge = userAgent.indexOf('Edge') > -1
  },
  methods: {
    getFile(imgsrc, name) {
      imgsrc = `${imgsrc}?time=${new Date().getTime()}`
      const image = new Image()
      // 解决跨域 Canvas 污染问题
      image.setAttribute('crossOrigin', 'Anonymous')
      image.onload = () => {
        const canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        const context = canvas.getContext('2d')
        context.drawImage(image, 0, 0, image.width, image.height)
        const url = canvas.toDataURL('image/png')
        const a = document.createElement('a')
        a.download = name
        a.href = url
        a.click()
      }
      image.src = imgsrc
    },
    downLoadFile(url, fileName) {
      const http = new XMLHttpRequest()
      http.open('GET', url, true)
      http.responseType = 'blob'
      http.onload = () => {
        const fileUrl = window.URL.createObjectURL(http.response)
        const a = document.createElement('a')
        a.href = fileUrl
        a.download = fileName
        a.click()
      }
      http.send()
    },
    async init() {
      const params = {
        id: this.$route.query.id
      }
      const res = await getNewsInfo({ params })
      const { data } = res
      this.title = data.title
      this.publishTime = data.publishTime
      this.origin = data.origin
      this.author = data.author
      this.editor = data.editor
      this.content = data.content
      this.countView = data.countView
      this.attachedList = data.attachedList
      this.attachedList.forEach((item) => {
        const nameArr = item.attachedName.split('.')
        item.type = ['jpg', 'jpeg', 'png'].includes(nameArr[nameArr.length - 1])
      })
    }
  }
}
</script>

<style lang="scss" scoped>
 .m-detail{
   margin-top: 30px;
   margin-bottom: 20px;
   border: #ccc 1px solid;
   background: #fff;
   padding: 30px 50px;
   .content_title{
     margin-bottom: 20px;
     padding: 20px;
     .title {
       line-height: 44px;
       font-size: 24px;
       color: rgb(51, 51, 51);
       font-weight: 700;
       white-space: normal;
       word-break: break-all;
       text-align: center;
     }
     .content-pics{
       margin-top: 20px;
       font-size: 14px;
       text-align: center;
       color: rgb(119, 119, 119);
       .content-detail{
         margin-right: 19px;
       }
     }
   }
   .content-info /deep/{
     line-height: 26px;

     img{
       max-width: 100%!important;
     }
     p{
       font-family: 'SimSun';
       line-height: 28px;
       font-size: 18px;
       color: #333;
       text-indent: 2em;
       padding: 5px 0px;
     }
     img{
       display: block;
       height: auto;
       margin: 0 auto;
     }
   }
   .infos{
     margin-top: 20px;
     border-top: 1px solid #f1f1f1;
     .title{
       height: 36px;
       line-height: 36px;
       font-weight: bold;
     }
     p{
       height: 38px;
       line-height: 38px;
       padding-left: 36px;
       a{
         float: right;
         display: inline-block;
         width: 78px;
         height: 28px;
         text-align: center;
         line-height: 28px;
         border-radius: 2px;
         border: 1px solid #2e69f9;
         color: #0166cc;
         margin-top: 5px;
         user-select: none;
         &:hover{
           background-color: #2e69f9;
           color: #fff;
         }
       }
     }
   }
  }
  .info-editor{
    font-family: 'Microsoft YaHei';
    text-align: right;
    margin-top: 76px;
    font-size: 16px;
  }
</style>
